// extracted by mini-css-extract-plugin
module.exports = {"smartDevicesTreaserH5":"treaser_smartDevicesTreaserH5__XIlyg"};